module Geisha.Controllers {
    export interface IRingCentralDialControllerScope extends ng.IScope {
        ctrl: any;
        message: string;
        phoneNumber: string;
        handedOffToExistingTab: boolean;
        closeBlocked: boolean;
    }

    export class RingCentralDialController {
        public static $inject = ["$scope", "$state", "$stateParams", "$window", "ringCentralService"];

        constructor(
            private $scope: IRingCentralDialControllerScope,
            private $state: ng.ui.IStateService,
            private $stateParams: ng.ui.IStateParamsService,
            private $window: ng.IWindowService,
            private ringCentralService: Geisha.Services.RingCentralService) {
            $scope.ctrl = this;
            $scope.phoneNumber = this.getRequestedPhoneNumber();
            $scope.handedOffToExistingTab = false;
            $scope.closeBlocked = false;

            if (!$scope.phoneNumber) {
                $scope.message = "No telephone number was provided.";
                this.returnToPreviousPage(800);
                return;
            }

            var dialResult = this.ringCentralService.beginExternalDial($scope.phoneNumber, this.getSource());
            $scope.phoneNumber = dialResult.phoneNumber;

            if (!dialResult.accepted) {
                $scope.message = "Unable to start the RingCentral call.";
                this.returnToPreviousPage(1000);
                return;
            }

            if (dialResult.handedOffToExistingTab) {
                $scope.handedOffToExistingTab = true;
                $scope.message = "Handing this call to your existing Atom tab.";
                this.tryCloseWindowSequence();
                return;
            }

            $scope.message = "Preparing your RingCentral call.";
            this.returnToPreviousPage(1200);
        }

        private getRequestedPhoneNumber() {
            return (this.$stateParams["number"] || "").toString();
        }

        private getSource() {
            return (this.$stateParams["source"] || "os-tel").toString();
        }

        private tryCloseWindow() {
            try {
                this.$window.close();
            } catch (e) {
            }
        }

        private tryCloseWindowSequence() {
            var attempts = 0;
            var maxAttempts = 6;

            var attemptClose = () => {
                attempts++;
                this.tryCloseWindow();

                try {
                    this.$window.open("", "_self");
                    this.tryCloseWindow();
                } catch (e) {
                }

                if (this.$window.closed) {
                    return;
                }

                if (attempts < maxAttempts) {
                    this.$window.setTimeout(attemptClose, 250);
                    return;
                }

                this.$scope.$evalAsync(() => {
                    this.$scope.closeBlocked = true;
                    this.$scope.message = "This call has been handed to your existing Atom tab.";
                });
            };

            this.$window.setTimeout(attemptClose, 150);
        }

        private returnToPreviousPage(delayMs: number) {
            this.$window.setTimeout(() => {
                var startingUrl = this.$window.location.href;

                if (this.$window.history && this.$window.history.length > 1) {
                    this.$window.history.back();

                    this.$window.setTimeout(() => {
                        if (this.$window.location.href === startingUrl) {
                            this.$scope.$evalAsync(() => {
                                this.$state.go("patients");
                            });
                        }
                    }, 500);

                    return;
                }

                this.$scope.$evalAsync(() => {
                    this.$state.go("patients");
                });
            }, delayMs);
        }
    }
}
